import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/PaymentsWeb/";
    return {
       SendCollectionsEmail(request) {
            const url = baseUrl + "SendCollectionsEmail";
            return Proxy.Post(url, request);
        }
    };
})()